import { useContext } from 'react'
import * as Yup from 'yup'

import { LiabilitiesContext } from '../../context'
import { R } from '@utils/currency'

export const setupValidations = () => {
  const { state } = useContext(LiabilitiesContext)
  const { liabilities, liability, formFields } = state
  const schema = {}
  const liabilityNames = getLiabilityNames(liabilities, liability)
  const liabilityValidations = buildLiabilityValidations(liabilityNames)
  const validationFields = [...formFields]
  validationFields.forEach((field) => {
    schema[field] = liabilityValidations[field]
  })
  return Yup.object().shape(schema)
}

const getLiabilityNames = (liabilities, currentLiability = {}) => {
  const liabilityNames = liabilities.map((liability) => liability.name)
  const indexTorRemove = liabilityNames.indexOf(currentLiability.name)
  if (indexTorRemove > -1) { liabilityNames.splice(indexTorRemove, 1) }

  return liabilityNames
}

const buildLiabilityValidations = (liabilityNames) => {
  const liabilityValidations = {
    name: Yup.string()
      .required('A name for the liability is required')
      .typeError('A valid name for the liability is required')
      .notOneOf(liabilityNames, 'A unique name for the liability is required'),
    value: Yup.number()
      .nullable()
      .test('liabilityHasValue', 'You have to enter the outstanding balance for your liability', liabilityValueTest)
      .typeError('A numeric value for the outstanding balance is required'),
    monthly_repayment: Yup.number()
      .nullable()
      .test('liabilityHasValue', 'You have to enter a monthly replayment', liabilityValueTest)
      .typeError('A numeric value for the monthly repayment is required'),
    interest_rate: Yup.number()
      .required('An interest rate value for the liability is required')
      .typeError('A numeric value for the interest rate is required'),
    term_of_debt: Yup.number().when('liability', {
      is: (liability) => isFinite(liability) && liability > 0,
      then: schema =>  schema
        .required('A term of debt for the liability is required')
        .min(1, 'This is not a realistic term of debt')
        .max(100, 'This is not a realistic term of debt')
        .typeError('A numeric value for the term of debt is required'),
      otherwise: schema => schema
        .nullable()
        .max(100, 'This is not a realistic term of debt')
        .typeError('A numeric value for the term of debt is required')
    })
  }
  return liabilityValidations
}

function liabilityValueTest () {
  const { monthly_repayment, value } = this.parent
  const testValue = R(monthly_repayment).value + R(value).value

  return testValue > 0
}
